var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _c("table", { staticClass: "basket-summary" }, [
      !_vm.quantity
        ? _c("tr", [
            _c("td", { attrs: { colspan: "2" } }, [
              _vm._v("There are no items in the basket"),
            ]),
          ])
        : _c("tr", [
            _c("th", [_vm._v("Total products")]),
            _vm._v(" "),
            _c("td", [_vm._v(_vm._s(_vm.quantity))]),
          ]),
      _vm._v(" "),
      _vm.basketValues.discount > 0
        ? _c("tr", [
            _c("th", [
              _vm._v("Discount Code Applied " + _vm._s(_vm.discountCode)),
            ]),
            _vm._v(" "),
            _vm.basketValues.discount
              ? _c(
                  "td",
                  {
                    staticClass: "y-basket-value",
                    staticStyle: { "white-space": "nowrap" },
                  },
                  [
                    _vm._v(
                      "-£ " + _vm._s(_vm._f("money")(_vm.basketValues.discount))
                    ),
                  ]
                )
              : _c(
                  "td",
                  {
                    staticClass: "y-basket-value",
                    staticStyle: { "white-space": "nowrap" },
                  },
                  [_vm._v("-£0")]
                ),
          ])
        : _vm._e(),
      _vm._v(" "),
      _c("tr", [
        _c("th", [_vm._v("Delivery:")]),
        _vm._v(" "),
        _vm.basketValues.shipping
          ? _c("td", [
              _vm._v("£ " + _vm._s(_vm._f("money")(_vm.basketValues.shipping))),
            ])
          : _c("td", { attrs: { colspan: "2" } }, [
              _vm._v("£ " + _vm._s(_vm._f("money")(0))),
            ]),
      ]),
      _vm._v(" "),
      _c("tr", [
        _c("th", [_vm._v("Total (net):")]),
        _vm._v(" "),
        _vm.basketValues.net
          ? _c("td", { attrs: { colspan: "2" } }, [
              _vm._v("£ " + _vm._s(_vm._f("money")(_vm.basketValues.net))),
            ])
          : _c("td", { attrs: { colspan: "2" } }, [
              _vm._v("£ " + _vm._s(_vm._f("money")(0))),
            ]),
      ]),
      _vm._v(" "),
      _c("tr", [
        _c("th", [_vm._v("VAT:")]),
        _vm._v(" "),
        _vm.basketValues.tax
          ? _c("td", { attrs: { colspan: "2" } }, [
              _vm._v("£" + _vm._s(_vm._f("money")(_vm.basketValues.tax))),
            ])
          : _c("td", { attrs: { colspan: "2" } }, [
              _vm._v("£ " + _vm._s(_vm._f("money")(0))),
            ]),
      ]),
      _vm._v(" "),
      _vm.basketValues.discount > 0
        ? _c("tr", [
            _c("th", [_vm._v("Discount:")]),
            _vm._v(" "),
            _vm.basketValues.discount
              ? _c("td", { attrs: { colspan: "2" } }, [
                  _vm._v(
                    "£" + _vm._s(_vm._f("money")(_vm.basketValues.discount))
                  ),
                ])
              : _c("td", { attrs: { colspan: "2" } }, [
                  _vm._v("£ " + _vm._s(_vm._f("money")(0))),
                ]),
          ])
        : _vm._e(),
      _vm._v(" "),
      _c("tr", [
        _c("th", [_vm._v("Total:")]),
        _vm._v(" "),
        _vm.basketValues.gross
          ? _c("td", { attrs: { colspan: "2" } }, [
              _vm._v("£" + _vm._s(_vm._f("money")(_vm.basketValues.gross))),
            ])
          : _c("td", { attrs: { colspan: "2" } }, [
              _vm._v("£ " + _vm._s(_vm._f("money")(0))),
            ]),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }